<template>
  <div>
    <div class="page-header bg-white border-bottom">
      <div class="container d-flex justify-content-start px-md-4 px-3">
        <h3>Profile</h3>
      </div>
    </div>
    <div v-if="$auth.user" class="container mb-5 mt-3">
      <div class="row justify-content-center">
        <!--Image-->
        <div class="col-md-6 col-12">
          <div class="card">
            <!--img class="card-img-top" :src="profile.picture"-->
            <h5 class="card-header"><a>{{ $auth.user.name }}</a></h5>
            <div class="card-body">
              <div class="card-text mb-5">
                <span>Email: </span><span class="date">{{ $auth.user.email }}</span>
              </div>
              <div class="mb-3">
                <router-link to="/authinfo" class="text-muted small">
                  <i class="fas fa-key me-1"></i>View authentication details (debug)
                </router-link>
              </div>
              <div v-if="showCompanyPickerLink">
                <router-link to="/pickCompanyOfInterest">
                   <b-button variant="primary">Pick Your Company</b-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    showCompanyPickerLink: {
      get: function () {
        return this.$store.state.userCompanies.length > 1
      }
    }
  }
}
</script>

<style scoped>
  .masthead.inverted.ui {
    background-image: url(../assets/images/img_grid-bg.jpg);
    background-color: #222;
    background-size: cover;
    background-position: center center;
}
.masthead.inverted > div{
  margin-bottom: -40px;
  margin-top: 70px;
}
.main.container{
  margin-top: 3em;
}
</style>



// WEBPACK FOOTER //
// src/views/Profile.vue